export function transformObjKeysToLowerCase(info) {
    if (!info) return null;
    for (const [key, value] of Object.entries(info)) {
        if (key.toLowerCase().indexOf('state') === -1) {
            if (typeof value === 'string' && value !== '') info[key] = value.toLowerCase();
            if (typeof value === 'object') transformObjKeysToLowerCase(value);
        }
    }

    return info;
}



// WEBPACK FOOTER //
// ./src/modules/string.js